import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {ForwardService} from '../../services/forward/forward.service';

@Injectable({
   providedIn: 'root'
})
export class ConsentDeclarationService {

   constructor (public sForward: ForwardService) {
   }

   public getAgreementURL (): Observable<boolean> {
      return this.sForward.loadConsent();
   }
}
